module.exports = __webpack_public_path__ + "src/assets/sounds/fail_sound.mp3";